const MS_PER_DAY = 24 * 60 * 60 * 1000

export function formatDate(date: Date, locale: string): string {
  return new Intl.DateTimeFormat(locale).format(date)
}

/**
 * Formats a Date as a timezone-less 'YYYY-MM-DD' calendar date using the
 * local date parts. Unlike `toISOString().split('T')[0]`, this never shifts
 * the day for users whose local time is ahead of UTC.
 */
export function formatDateISO(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function formatDateRange(
  dateRange: [Date, Date],
  locale: string,
): string {
  return new Intl.DateTimeFormat(locale).formatRange(dateRange[0], dateRange[1])
}

export function getTotalDatesFromRange(dateRange: [Date, Date]): number {
  const start = startOfDay(dateRange[0])
  const end = startOfDay(dateRange[1])
  const totalDays = Math.round((end - start) / MS_PER_DAY)
  return totalDays + 1
}

function startOfDay(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime()
}
